/*
  (C) Belvano: "In den Warenkorb gelegt"-Popup.
  Wird aus cart-subtotal.liquid (Drawer-Zweig) geladen; baut sein Markup selbst
  in den <body> (der Drawer selbst ist display:none — dort kann kein Markup leben).

  - fängt das 'add-to-cart'-Event der product-forms in der Capture-Phase ab
    (feuert dort VOR den Theme-Listenern, die den Drawer öffnen)
  - unterdrückt das nächste site-cart-sidebar.show() einmalig
  - Bett (Tag "Boxspringbett") → Popup: Schritte (Warenkorb ✓ → Lieferung → Kasse),
    Produkt, Cross-Sells, Buttons "Weiter stöbern" (outline) / "Lieferung planen" (solid)
  - kein Bett oder Fehler → Drawer öffnet normal (Fallback)
  Cross-Sells: Shopify-Recommendations (complementary, Fallback related).
*/

(function () {
  if (window.bvapInit) return;
  window.bvapInit = true;

  const CART_URL = '/cart';

  /* ---------- Markup ---------- */

  const root = document.createElement('div');
  root.className = 'bvap';
  root.hidden = true;
  root.innerHTML = `
    <div class="bvap__overlay" data-js-bvap-close></div>
    <div class="bvap__dialog" role="dialog" aria-modal="true" aria-label="In den Warenkorb gelegt">
      <button type="button" class="bvap__close" data-js-bvap-close aria-label="Schliessen">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </button>
      <div class="bvap__steps" aria-label="Bestellschritte"></div>
      <p class="bvap__added">In den Warenkorb gelegt</p>
      <div class="bvap__product" data-js-bvap-product></div>
      <div class="bvap__upsell" data-js-bvap-upsell></div>
      <div class="bvap__cross" data-js-bvap-cross hidden>
        <p class="bvap__cross-title">Passt dazu</p>
        <div class="bvap__cross-items" data-js-bvap-cross-items></div>
      </div>
      <div class="bvap__plan" data-js-bvap-plan hidden></div>
      <div class="bvap__actions" data-js-bvap-actions-1>
        <button type="button" class="button button--outline bvap__btn-back" data-js-bvap-close>
          <span class="button__text">Weiter stöbern</span>
        </button>
        <button type="button" class="button button--solid button--move bvap__btn-next" data-js-bvap-plan-open>
          <span class="button__text">Lieferung planen&nbsp;&rarr;</span>
        </button>
      </div>
      <div class="bv-ordersum bv-ordersum--popup" data-js-bvap-summary hidden></div>
      <div class="bvap__actions" data-js-bvap-actions-2 hidden>
        <button type="button" class="button button--outline bvap__btn-back" data-js-bvap-plan-back>
          <span class="button__text">&larr; Zurück</span>
        </button>
        <button type="button" class="button button--solid button--move bvap__btn-next" data-js-bvap-checkout>
          <span class="button__text">Zur Kasse&nbsp;&rarr;</span>
        </button>
      </div>
    </div>
  `;
  document.body.appendChild(root);

  const productSlot = root.querySelector('[data-js-bvap-product]');
  const upsellSlot = root.querySelector('[data-js-bvap-upsell]');
  const crossWrap = root.querySelector('[data-js-bvap-cross]');
  const crossItems = root.querySelector('[data-js-bvap-cross-items]');
  let currentProductId = null;
  // Konkrete Zeile, um die es im Popup geht (Varianten-ID der zuletzt hinzugefügten
  // bzw. zuletzt getauschten Zeile). NÖTIG, weil dasselbe Produkt mehrfach im
  // Warenkorb liegen kann (z. B. Hamilton 160 UND 180) — nur die Produkt-ID würde
  // immer die ERSTE Zeile treffen und den Zusatz der falschen Grösse zuordnen.
  let currentVariantId = null;

  /* ---------- Drawer-Unterdrückung ---------- */

  let suppressUntil = 0;

  // Lazy beim ersten Add-to-Cart wrappen — beim Script-Load ist das
  // sidebar-drawer-Custom-Element evtl. noch nicht upgegradet.
  function ensureSidebarWrapped() {
    const sidebar = document.getElementById('site-cart-sidebar');
    if (!sidebar || sidebar.bvOrigShow || typeof sidebar.show !== 'function') return sidebar;
    const origShow = sidebar.show.bind(sidebar);
    sidebar.show = function () {
      if (Date.now() < suppressUntil) return;
      return origShow();
    };
    sidebar.bvOrigShow = origShow;
    return sidebar;
  }

  function openDrawerFallback() {
    suppressUntil = 0;
    const sidebar = document.getElementById('site-cart-sidebar');
    if (sidebar && sidebar.bvOrigShow) sidebar.bvOrigShow();
    else if (sidebar && typeof sidebar.show === 'function') sidebar.show();
  }

  /* ---------- Popup öffnen/schliessen ---------- */

  function openPopup() {
    if (typeof showPlanView === 'function') showPlanView(false);
    root.hidden = false;
    document.documentElement.classList.add('bvap-open');
    const closeBtn = root.querySelector('.bvap__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closePopup() {
    root.hidden = true;
    document.documentElement.classList.remove('bvap-open');
  }

  root.querySelectorAll('[data-js-bvap-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  /* ---------- Bestellübersicht + Ratenzahlung (Schritt 2) ---------- */

  const chfFmt = new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' });
  const chf = (rappen) => chfFmt.format((rappen || 0) / 100);

  // Laufzeit-Logik 1:1 wie belvano-heylight-cart.liquid (Mindestrate 200,
  // Stufen 3/4/6/10/12, Bestellwert 600–5000 CHF; Beträge in Rappen).
  function heylightTerm(total) {
    const MIN_RATE = 20000, MIN = 60000, MAX = 2000000, TERMS = [3, 4, 6, 10, 12];
    if (total < MIN || total > MAX) return null;
    const ceiling = total / MIN_RATE;
    let term = null;
    TERMS.forEach((t) => { if (t <= ceiling) term = t; });
    return term;
  }

  // Gesamtbetrag (aufklappbar → Bestellliste mit Bild/Produkt/Preis + Entfernen)
  // + HeyLight-Rate. opts: { total: bool, heylight: bool, id: string }
  function renderOrderSummary(container, opts) {
    if (!container) return Promise.resolve();
    const wasOpen = container.classList.contains('is-open');
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const term = opts.heylight ? heylightTerm(cart.total_price) : null;
        const heylightHtml = term
          ? `<div class="bv-ordersum__rate">oder ${term}&nbsp;&times;&nbsp;<strong>${chf(Math.round(cart.total_price / term))}</strong><button type="button" class="blv-hl-i" data-heylight-info data-hl-amount="${cart.total_price}" aria-label="Ratenzahlung mit HeyLight — Infos"><svg class="bv-stroke-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.4"/><path d="M10 9v4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="10" cy="6.4" r="1" fill="currentColor"/></svg></button></div>`
          : '';

        // Versteckte Service-Position (Altmöbelentsorgung) wird im Planner
        // verwaltet → hier nicht als entfernbare Zeile listen.
        const items = (cart.items || []).filter((it) => it.handle !== 'altmobelentsorgung');
        const itemsHtml = items.map((it) => {
          const img = it.image || (it.featured_image && it.featured_image.url) || '';
          const opt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
          const price = it.final_line_price != null ? it.final_line_price : it.line_price;
          return `<div class="bv-ordersum__item">
              <span class="bv-ordersum__item-img">${img ? `<img src="${esc(img)}" alt="" width="40" height="40" loading="lazy">` : ''}</span>
              <span class="bv-ordersum__item-txt">
                <span class="bv-ordersum__item-title">${esc(it.product_title || it.title)}</span>
                ${opt ? `<span class="bv-ordersum__item-opt">${esc(opt)}</span>` : ''}
              </span>
              <span class="bv-ordersum__item-price">${chf(price)}</span>
              <button type="button" class="bv-ordersum__item-remove" data-js-ordersum-remove="${esc(it.key)}" aria-label="Entfernen" title="Entfernen">&times;</button>
            </div>`;
        }).join('');

        const totalRow = opts.total ? `
          <button type="button" class="bv-ordersum__toggle" data-js-ordersum-toggle aria-expanded="${wasOpen ? 'true' : 'false'}">
            <span class="bv-ordersum__toggle-l">
              <svg class="bv-ordersum__chev bv-stroke-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8"/></svg>
              <span class="bv-ordersum__label">Gesamtbetrag</span>
            </span>
            <span class="bv-ordersum__total">${chf(cart.total_price)}</span>
          </button>` : '';

        container.classList.toggle('is-open', wasOpen);
        container.innerHTML = `${totalRow}<div class="bv-ordersum__items" data-js-ordersum-items ${wasOpen ? '' : 'hidden'}>${itemsHtml}</div>${heylightHtml}`;

        const toggle = container.querySelector('[data-js-ordersum-toggle]');
        const itemsEl = container.querySelector('[data-js-ordersum-items]');
        if (toggle && itemsEl) {
          toggle.addEventListener('click', () => {
            const willOpen = itemsEl.hidden;
            itemsEl.hidden = !willOpen;
            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            container.classList.toggle('is-open', willOpen);
          });
        }

        container.querySelectorAll('[data-js-ordersum-remove]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const key = btn.getAttribute('data-js-ordersum-remove');
            btn.disabled = true;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({ id: key, quantity: 0 })
            })
              .then(() => {
                if (typeof window.refreshCart === 'function') { try { window.refreshCart(false); } catch (e) {} }
                document.dispatchEvent(new CustomEvent('bv:cart-changed'));
              })
              .catch(() => {});
          });
        });
      })
      .catch(() => {});
  }

  /* ---------- Stepper: volle Breite, nur das aktive Label sichtbar ---------- */

  const CHECK_SVG = '<svg class="bvap__check bv-stroke-icon" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.25 8.4L6.25 12.25L13.75 3.75" stroke="currentColor" stroke-width="2.25" stroke-linecap="square" stroke-linejoin="miter"/></svg>';
  const STEP_LABELS = { 1: 'Warenkorb', 2: 'Lieferung planen', 3: 'Kasse' };

  function stepBadge(i, state) {
    const num = document.createElement('span');
    num.className = 'bvap__step-num'
      + (state === 'done' ? ' bvap__step-num--done' : '')
      + (state === 'active' ? ' bvap__step-num--active' : '');
    num.setAttribute('aria-hidden', 'true');
    num.innerHTML = state === 'done' ? CHECK_SVG : String(i);
    return num;
  }

  function stepConn() {
    const c = document.createElement('span');
    c.className = 'bvap__step-conn';
    return c;
  }

  function renderSteps(container, n) {
    container.innerHTML = '';
    for (let i = 1; i <= 3; i++) {
      if (i > 1) container.appendChild(stepConn());
      const item = document.createElement('span');
      item.className = 'bvap__step' + (i === n ? ' bvap__step--active' : '');
      item.dataset.jsStep = i;
      // Schritt 2 ist von Schritt 1 aus per Klick auf die „2" erreichbar.
      if (i === 2 && n === 1) {
        item.classList.add('bvap__step--clickable');
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', 'Weiter zu Schritt 2: ' + (STEP_LABELS[2] || ''));
      }
      item.appendChild(stepBadge(i, i < n ? 'done' : i === n ? 'active' : 'todo'));
      if (i === n) {
        const label = document.createElement('span');
        label.className = 'bvap__step-label';
        label.textContent = STEP_LABELS[i] || '';
        item.appendChild(label);
      }
      container.appendChild(item);
    }
    container.setAttribute('aria-label', `Schritt ${n} von 3: ${STEP_LABELS[n] || ''}`);
  }

  // Klick/Enter/Space auf die „2" im Stepper → Schritt 2 öffnen. Delegation am
  // (persistenten) Container, damit es das renderSteps-Neurendern überlebt.
  function wireStepperNav(container, goStep2) {
    if (!container) return;
    container.addEventListener('click', (e) => {
      if (e.target.closest('[data-js-step="2"].bvap__step--clickable')) goStep2();
    });
    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest('[data-js-step="2"].bvap__step--clickable')) {
        e.preventDefault();
        goStep2();
      }
    });
  }

  function setStep(n) {
    renderSteps(root.querySelector('.bvap__steps'), n);
  }

  /* ---------- Schritt 2 im Popup: Lieferung planen (Cart-Page überspringen) ---------- */

  const planSlot = root.querySelector('[data-js-bvap-plan]');
  const actions1 = root.querySelector('[data-js-bvap-actions-1]');
  const actions2 = root.querySelector('[data-js-bvap-actions-2]');
  const bvapSummary = root.querySelector('[data-js-bvap-summary]');
  const planOpenBtn = root.querySelector('[data-js-bvap-plan-open]');

  function showPlanView(on) {
    const step1Els = [
      root.querySelector('.bvap__added'),
      productSlot,
      upsellSlot,
      crossWrap.hidden ? null : crossWrap,
    ];
    step1Els.forEach((el) => { if (el) el.hidden = on; });
    // crossWrap kann leer/hidden sein — Zustand beim Zurückblättern korrekt herstellen
    if (!on && crossItems.children.length) crossWrap.hidden = false;
    planSlot.hidden = !on;
    actions1.hidden = on;
    actions2.hidden = !on;
    if (bvapSummary) {
      bvapSummary.hidden = !on;
      if (on) renderOrderSummary(bvapSummary, { total: true, heylight: true, id: 'bvap' });
    }
    setStep(on ? 2 : 1);
    root.querySelector('.bvap__dialog').scrollTop = 0;
  }

  // Cart-Änderung (z. B. Altmöbelentsorgung im Planner) → Übersicht/Rate neu.
  document.addEventListener('bv:cart-changed', () => {
    if (bvapSummary && !bvapSummary.hidden) {
      renderOrderSummary(bvapSummary, { total: true, heylight: true, id: 'bvap' });
    }
  });

  // Planner-Komponente samt Assets von der Cart-Page holen — dieselbe
  // Section wie auf /cart, inkl. Editor-Settings und Attribute-Prefill.
  // Wird vom Popup UND vom Drawer (Schritt 2 im Drawer) genutzt.
  // Stylesheet sicher geladen haben, BEVOR der Planner in den DOM kommt —
  // sonst blitzt der Inhalt kurz unformatiert auf (FOUC / Layout-Shift).
  function ensurePlannerCss(href) {
    return new Promise((resolve) => {
      if (!href) { resolve(); return; }
      const existing = document.querySelector('link[href*="belvano-delivery-planner.css"]');
      if (existing) {
        // schon vorhanden — sheet zugänglich = fertig geladen, sonst auf load warten
        if (existing.sheet) { resolve(); return; }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', resolve, { once: true });
        setTimeout(resolve, 1500); // Fallback, falls load nie feuert
        return;
      }
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.addEventListener('load', resolve, { once: true });
      l.addEventListener('error', resolve, { once: true });
      document.head.appendChild(l);
      setTimeout(resolve, 1500);
    });
  }

  function fetchPlannerInto(slot) {
    return fetch(CART_URL)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const planner = doc.querySelector('belvano-delivery-planner');
        if (!planner) throw new Error('kein Planner auf /cart');
        const scr = doc.querySelector('script[src*="belvano-delivery-planner.js"]');
        if (scr && !document.querySelector('script[src*="belvano-delivery-planner.js"]')) {
          const s = document.createElement('script');
          s.src = scr.getAttribute('src');
          document.head.appendChild(s);
        }
        const css = doc.querySelector('link[href*="belvano-delivery-planner.css"]');
        // CSS zuerst fertig laden, DANN den Knoten einsetzen → kein FOUC.
        return ensurePlannerCss(css ? css.getAttribute('href') : null).then(() => {
          slot.appendChild(document.importNode(planner, true));
        });
      });
  }

  function openPlanStep() {
    if (planSlot.querySelector('belvano-delivery-planner')) { showPlanView(true); return; }
    planOpenBtn.classList.add('working');
    fetchPlannerInto(planSlot)
      .then(() => showPlanView(true))
      .catch(() => { window.location.href = CART_URL; })
      .finally(() => planOpenBtn.classList.remove('working'));
  }

  planOpenBtn.addEventListener('click', openPlanStep);
  wireStepperNav(root.querySelector('.bvap__steps'), openPlanStep);
  root.querySelector('[data-js-bvap-plan-back]').addEventListener('click', () => showPlanView(false));

  root.querySelector('[data-js-bvap-checkout]').addEventListener('click', (e) => {
    const btn = e.currentTarget;
    const planner = planSlot.querySelector('belvano-delivery-planner');
    // Komponente (noch) nicht einsatzbereit → sicherer Weg über die Cart-Page
    if (!planner || typeof planner.isValid !== 'function') {
      window.location.href = CART_URL;
      return;
    }
    if (!planner.isValid()) {
      if (typeof planner.showError === 'function') planner.showError();
      return;
    }
    btn.classList.add('working');
    setStep(3);
    finalizeAndCheckout(planner);
  });

  // Attribute + Anmerkung final syncen (der interne Sync ist debounced — Race
  // vermeiden), dann zur Kasse.
  function finalizeAndCheckout(planner) {
    const go = () => { window.location.href = '/checkout'; };
    const payload = typeof planner.updatePayload === 'function'
      ? planner.updatePayload()
      : typeof planner.attributePayload === 'function'
        ? { attributes: planner.attributePayload() }
        : null;
    if (!payload) { go(); return; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(go).catch(go);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !root.hidden) closePopup();
  });

  /* ---------- Helpers ---------- */

  function money(cents) {
    const chf = Math.round(cents) / 100;
    const str = chf % 1 === 0 ? String(chf) : chf.toFixed(2);
    return `CHF ${str.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}`;
  }

  function esc(s) {
    const div = document.createElement('div');
    div.textContent = s == null ? '' : String(s);
    return div.innerHTML;
  }

  function fetchProductJson(productUrl) {
    const path = productUrl.split('?')[0];
    return fetch(`${path}.js`).then((r) => {
      if (!r.ok) throw new Error(`product.js ${r.status}`);
      return r.json();
    });
  }

  function refreshCartUi() {
    // Drawer-Inhalt + Header-Zähler aktualisieren (gleiches Muster wie das Theme)
    fetch('?section_id=helper-cart')
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const form = html.getElementById('AjaxCartForm');
        const subtotal = html.getElementById('AjaxCartSubtotal');
        const liveForm = document.getElementById('AjaxCartForm');
        const liveSubtotal = document.getElementById('AjaxCartSubtotal');
        if (form && liveForm) {
          liveForm.innerHTML = form.innerHTML;
          if (typeof liveForm.ajaxifyCartItems === 'function') liveForm.ajaxifyCartItems();
        }
        if (subtotal && liveSubtotal) liveSubtotal.innerHTML = subtotal.innerHTML;
        const count = html.querySelector('[data-cart-count]');
        const total = html.querySelector('[data-cart-total]');
        if (count) document.querySelectorAll('[data-header-cart-count]').forEach((el) => { el.textContent = count.textContent; });
        if (total) document.querySelectorAll('[data-header-cart-total]').forEach((el) => { el.textContent = total.textContent; });
        syncFromDrawer();
      })
      .catch(() => {});
  }

  /* ---------- Zusätze (Nachttisch/Bettbank/Pouf) aus dem Drawer klonen ---------- */

  // Die belvano-cart-upsell-Karten werden serverseitig pro Warenkorb-Zeile in den
  // Drawer gerendert. Wir klonen die Karten der zuletzt hinzugefügten Zeile ins
  // Popup — das Custom Element bindet seine Buttons beim Einfügen selbst neu.
  // Nach einem Swap ersetzt das Upsell-JS den Drawer-Inhalt und feuert
  // 'cart-updated' auf #AjaxCartForm → wir synchronisieren das Popup nach.

  function findRowAndUpsell() {
    const form = document.getElementById('AjaxCartForm');
    if (!form) return {};
    // Zuerst die EXAKTE Zeile über die Varianten-ID suchen (mehrere Grössen
    // desselben Produkts liegen sonst gleich → falsche Zuordnung). Fallback auf
    // Produkt-ID und – zur Not – die erste Zeile.
    let row = currentVariantId
      ? form.querySelector(`[data-js-cart-item][data-variant="${currentVariantId}"]`)
      : null;
    if (!row && currentProductId) {
      row = form.querySelector(`[data-js-cart-item][data-product-id="${currentProductId}"]`);
    }
    if (!row) row = form.querySelector('[data-js-cart-item]');
    if (!row) return {};
    let el = row.nextElementSibling;
    while (el && el.tagName !== 'BELVANO-CART-UPSELL' && !el.hasAttribute('data-js-cart-item')) {
      el = el.nextElementSibling;
    }
    return { row, upsell: el && el.tagName === 'BELVANO-CART-UPSELL' ? el : null };
  }

  function syncFromDrawer() {
    if (root.hidden) return;
    const { row, upsell } = findRowAndUpsell();
    // Aufgelöste Zeile (ggf. per Fallback) merken, damit Folge-Syncs stabil
    // dieselbe Zeile treffen.
    if (row && row.dataset.variant) currentVariantId = String(row.dataset.variant);
    upsellSlot.innerHTML = '';
    if (upsell) {
      const clone = upsell.cloneNode(true);
      upsellSlot.appendChild(clone);
      // Ein Swap tauscht die Variante DIESER Zeile (neue Varianten-ID/Line-Key).
      // Ziel-Variante beim Klick merken, damit der durch 'cart-updated' ausgelöste
      // Folge-Sync wieder DIESE getauschte Zeile findet — nicht die erste Zeile
      // desselben Produkts.
      clone.querySelectorAll('[data-bvu-swap]').forEach((b) => {
        b.addEventListener('click', () => {
          if (b.dataset.targetVariant) currentVariantId = String(b.dataset.targetVariant);
        });
      });
    }
    if (!row) return;
    // Variante + Preis nachziehen (ändern sich beim Zusatz-Swap)
    const m = (row.dataset.title || '').match(/\(([^)]+)\)\s*$/);
    const variantEl = productSlot.querySelector('.bvap__product-variant');
    if (m && variantEl) variantEl.textContent = m[1];
    const priceSrc = row.querySelector('.cart-item__price strong')
      || row.querySelector('.cart-item__price span:not(.visually-hidden)');
    const priceEl = productSlot.querySelector('.bvap__product-price');
    if (priceSrc && priceEl) priceEl.textContent = priceSrc.textContent.trim();
    const qtyEl = productSlot.querySelector('.bvap__product-qty');
    if (qtyEl && row.dataset.qty) qtyEl.textContent = `Menge: ${row.dataset.qty}`;
  }

  const drawerForm = document.getElementById('AjaxCartForm');
  if (drawerForm) drawerForm.addEventListener('cart-updated', syncFromDrawer);

  /* ---------- Inhalt füllen ---------- */

  function renderProduct(product, variantId, qty) {
    const variant = product.variants.find((v) => String(v.id) === String(variantId)) || product.variants[0];
    const image = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
    const imgHtml = image
      ? `<img class="bvap__product-img" src="${esc(image)}${image.includes('?') ? '&' : '?'}width=180" alt="" loading="lazy">`
      : '';
    // Kurztitel: Zusätze wie "– Samt Grau · mit Bettkasten · inkl. …" abschneiden,
    // die Details stehen ohnehin in der Variantenzeile
    const shortTitle = product.title.split('–')[0].trim() || product.title;
    const variantHtml = variant && variant.title && variant.title !== 'Default Title'
      ? `<span class="bvap__product-variant">${esc(variant.title)}</span>`
      : '';
    productSlot.innerHTML = `
      ${imgHtml}
      <div class="bvap__product-info">
        <span class="bvap__product-title">${esc(shortTitle)}</span>
        ${variantHtml}
        <span class="bvap__product-qty">Menge: ${parseInt(qty, 10) || 1}</span>
        <span class="bvap__product-price">${money(variant ? variant.price : product.price)}</span>
      </div>
    `;
  }

  function crossCard(product) {
    const singleVariant = product.variants && product.variants.length === 1;
    const img = product.featured_image
      ? `<img class="bvap__cross-img" src="${esc(product.featured_image)}${product.featured_image.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">`
      : '';
    const card = document.createElement('div');
    card.className = 'bvap__cross-card';
    card.innerHTML = `
      <a class="bvap__cross-link" href="${esc(product.url)}">
        ${img}
        <span class="bvap__cross-info">
          <span class="bvap__cross-name">${esc(product.title)}</span>
          <span class="bvap__cross-price">${money(product.price)}</span>
        </span>
      </a>
      <button type="button" class="bvap__cross-add" aria-label="${esc(product.title)} hinzufügen">+</button>
    `;
    const addBtn = card.querySelector('.bvap__cross-add');
    if (singleVariant) {
      addBtn.addEventListener('click', () => {
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: product.variants[0].id, quantity: 1 }),
        })
          .then((r) => {
            if (!r.ok) throw new Error();
            addBtn.textContent = '✓';
            addBtn.classList.add('bvap__cross-add--done');
            refreshCartUi();
          })
          .catch(() => {
            addBtn.disabled = false;
          });
      });
    } else {
      // Mehrere Varianten → zur Produktseite statt Blind-Add
      addBtn.addEventListener('click', () => { window.location.href = product.url; });
    }
    return card;
  }

  function loadCrossSells(productId) {
    crossWrap.hidden = true;
    crossItems.innerHTML = '';
    const load = (intent) =>
      fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=${intent}`)
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => d.products || []);

    // Nur echte Cross-Sells (Search & Discovery "Ergänzende Produkte") —
    // ohne gepflegte Ergänzungen bleibt der Block ausgeblendet (kein Related-Fallback).
    load('complementary')
      .then((products) => {
        const list = products.filter((p) => p.available !== false).slice(0, 3);
        if (!list.length) return;
        list.forEach((p) => crossItems.appendChild(crossCard(p)));
        crossWrap.hidden = false;
      })
      .catch(() => {});
  }

  /* ---------- Add-to-Cart abfangen ---------- */

  document.addEventListener(
    'add-to-cart',
    (e) => {
      // e.target ist das <product-form>-Element. Achtung: data-product-url gibt es
      // in diesem Theme NICHT (toter Code der popup-Variante) — Handle deshalb
      // über /cart.js (neueste Zeile = gerade hinzugefügt) auflösen.
      const form = e.target;
      if (!form || typeof form.querySelector !== 'function') return;
      const variantInput = form.querySelector('input[name="id"]');
      const variantId = variantInput ? variantInput.value : null;

      // Drawer-Open der Theme-Listener (laufen gleich danach) einmalig blocken
      ensureSidebarWrapped();
      suppressUntil = Date.now() + 1500;

      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const items = cart.items || [];
          // Plausibilität: neueste Zeile sollte zur hinzugefügten Variante passen
          let item = items[0];
          if (variantId) {
            const match = items.find((i) => String(i.variant_id) === String(variantId));
            if (match) item = match;
          }
          if (!item || !item.handle) throw new Error('kein Cart-Item');
          return fetchProductJson(`/products/${item.handle}`).then((product) => ({ product, item }));
        })
        .then(({ product, item }) => {
          if ((product.tags || []).includes('Boxspringbett')) {
            currentProductId = product.id;
            // Genau die gerade hinzugefügte Zeile adressieren (nicht bloss das Produkt),
            // sonst würde bei mehreren Grössen desselben Betts die falsche getroffen.
            currentVariantId = String(item.variant_id);
            renderProduct(product, variantId, item.quantity);
            loadCrossSells(product.id);
            openPopup();
            syncFromDrawer();
          } else {
            openDrawerFallback();
          }
        })
        .catch(() => {
          openDrawerFallback();
        });
    },
    true
  );

  /* ---------- Cart-Drawer: Steps-Leiste + Schritt 2 (Lieferung planen) ---------- */

  // Bett im Warenkorb → Drawer wird Teil des Step-Flows: Steps unter dem Header,
  // "Weiter zur Lieferung" lädt den Planner direkt in den Drawer (Body-Inhalte
  // weichen, im Footer bleibt nur der Gesamtbetrag + Zurück/Zur-Kasse).
  (function initDrawerFlow() {
    const drawer = document.getElementById('site-cart-sidebar');
    if (!drawer) return;
    const header = drawer.querySelector('.sidebar__header');
    const body = drawer.querySelector('.sidebar__body');
    const footer = drawer.querySelector('.sidebar__footer');
    if (!header || !body || !footer) return;

    const dSteps = document.createElement('div');
    dSteps.className = 'bvap__steps bv-drawer-steps hide-if-empty-cart';
    dSteps.hidden = true;
    header.insertAdjacentElement('afterend', dSteps);

    const dPlan = document.createElement('div');
    dPlan.className = 'bv-drawer-plan';
    dPlan.hidden = true;
    body.appendChild(dPlan);

    const dActions = document.createElement('div');
    dActions.className = 'bvap__actions bv-drawer-actions';
    dActions.hidden = true;
    dActions.innerHTML = `
      <button type="button" class="button button--outline" data-js-bv-plan-back>
        <span class="button__text">&larr; Zurück</span>
      </button>
      <button type="button" class="button button--solid button--move" data-js-bv-plan-checkout>
        <span class="button__text">Zur Kasse&nbsp;&rarr;</span>
      </button>
    `;
    footer.appendChild(dActions);

    // Gesamtbetrag + HeyLight-Rate liefert der Drawer im Plan-Modus selbst
    // (.cart__total + belvano-heylight-cart, per CSS sichtbar) — keine eigene
    // Zusatz-Komponente nötig.

    let planMode = false;
    let planLoading = false;

    function hasBed() {
      return !!drawer.querySelector('[data-js-bv-plan-open]');
    }

    function setPlanMode(on) {
      planMode = on;
      drawer.classList.toggle('bv-plan-mode', on);
      dPlan.hidden = !on;
      dActions.hidden = !on;
      renderSteps(dSteps, on ? 2 : 1);
      drawer.scrollTop = 0; // die Sidebar selbst ist der Scroll-Container
    }

    // Nach jedem Cart-Re-Render prüfen: Bett (noch) drin? Steps zeigen bzw.
    // Plan-Modus sauber verlassen (z.B. Bett im Schritt 2 entfernt).
    function refreshDrawerState() {
      const bed = hasBed();
      drawer.classList.toggle('bv-has-bed', bed);
      dSteps.hidden = !bed;
      if (!bed && planMode) setPlanMode(false);
      else if (bed && !planMode) renderSteps(dSteps, 1);
    }

    function openDrawerPlan() {
      if (dPlan.querySelector('belvano-delivery-planner')) { setPlanMode(true); return; }
      if (planLoading) return;
      planLoading = true;
      fetchPlannerInto(dPlan)
        .then(() => setPlanMode(true))
        .catch(() => { window.location.href = CART_URL; })
        .finally(() => { planLoading = false; });
    }

    function drawerCheckout(btn) {
      const planner = dPlan.querySelector('belvano-delivery-planner');
      // Komponente (noch) nicht einsatzbereit → sicherer Weg über die Cart-Page
      if (!planner || typeof planner.isValid !== 'function') {
        window.location.href = CART_URL;
        return;
      }
      if (!planner.isValid()) {
        if (typeof planner.showError === 'function') planner.showError();
        return;
      }
      btn.classList.add('working');
      renderSteps(dSteps, 3);
      finalizeAndCheckout(planner);
    }

    drawer.addEventListener('click', (e) => {
      const open = e.target.closest('[data-js-bv-plan-open]');
      if (open) {
        e.preventDefault();
        openDrawerPlan();
        return;
      }
      if (e.target.closest('[data-js-bv-plan-back]')) {
        setPlanMode(false);
        return;
      }
      const checkout = e.target.closest('[data-js-bv-plan-checkout]');
      if (checkout) drawerCheckout(checkout);
    });

    wireStepperNav(dSteps, openDrawerPlan);

    const subtotal = document.getElementById('AjaxCartSubtotal');
    if (subtotal) {
      new MutationObserver(refreshDrawerState).observe(subtotal, { childList: true, subtree: true });
    }
    refreshDrawerState();
  })();
})();
